import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-home-placeholder',
  templateUrl: './home-placeholder.component.html',
  styleUrls: ['./home-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class HomePlaceholderComponent {}
